import React from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';

const Jobs = ({ relationship }) => {
  const { initializingError, isInitializing } = usePageContentContext();
  return (
    <DataContainer
      component={Content}
      componentProps={{ relationship }}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

Jobs.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default Jobs;
